import { Drawer } from '@material-ui/core';
import React from 'react';
import { Dispatch } from 'redux';
import { connect } from '@optum-uhone-hmkts/rise';
import { setDrawerStatus } from '../../actions/access_page_actions';
import SideMenu from './side_menu';
import { AppState } from '../../reducers';

interface StateProps {
	drawerOpenStatus: boolean;
	isAuthenticated: boolean;
	isDesktop: boolean;
	needsTermsAndConditions: boolean;
	needsPin: boolean;
	clickToCallEnabled: boolean;
	isSideMenuVisible:boolean;
}
interface DispatchProps {
	setDrawerStatus(visible: boolean): void;
}
type Props = StateProps & DispatchProps;

class _SideMenuWrapper extends React.PureComponent<Props> {

	componentDidUpdate(prevProps: Props) {
		if (
			prevProps.isAuthenticated !== this.props.isAuthenticated ||
			prevProps.isDesktop !== this.props.isDesktop ||
			prevProps.needsTermsAndConditions !== this.props.needsTermsAndConditions ||
			prevProps.needsPin !== this.props.needsPin
		) {
			const {
				isAuthenticated,
				isDesktop,
				needsTermsAndConditions,
				needsPin,
			} = this.props;

			this.props.setDrawerStatus(
				isAuthenticated &&
				isDesktop &&
				!needsPin &&
				!needsTermsAndConditions
			);
		}
	}

	render() {
		const { drawerOpenStatus, clickToCallEnabled, isSideMenuVisible } = this.props;
		return (
			(!clickToCallEnabled && isSideMenuVisible) && (
				<Drawer
					key={'DesktopDrawer'}
					open={drawerOpenStatus}
					variant={this.props.isDesktop ? 'persistent' : 'temporary'}
					onClose={() => this.props.setDrawerStatus(false)}
					keepMounted
				>
					<SideMenu/>
				</Drawer>	
			)
		);
	}
}

const mapStateToProps = (state: AppState): StateProps => ({
	drawerOpenStatus: state.accessPage.drawerOpenStatus && !!state.user.id,
	isAuthenticated: state.authentication.isAuthenticated,
	isDesktop: state.layout.desktop,
	needsTermsAndConditions: !state.user.acceptanceDate,
	needsPin: state.authentication.needsPin,
	clickToCallEnabled: state.clickToCall.enabled,
	isSideMenuVisible: state.layout.isSideMenuVisible
});
const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
	setDrawerStatus: (visible: boolean) => dispatch(setDrawerStatus(visible)),
});

export const SideMenuWrapper = connect(mapStateToProps, mapDispatchToProps, true)(_SideMenuWrapper);
